import { DefinitionTemplate } from './hooks/useCreateEvent';
import EventDetailsForm from './EventDetailsForm';

export default function CreateEventStepOne({
    onNext,
    recordValues,
    eventName,
    setEventName,
    eventDate,
    setEventDate,
    eventLocation,
    setEventLocation,
}: {
    onNext: () => void;
    recordValues: (
        values: Record<
            string,
            string | Date | boolean | DefinitionTemplate | null | number
        >,
    ) => void;
    eventName: string;
    setEventName: (eventName: string) => void;
    eventDate: Date;
    setEventDate: (eventDate: Date) => void;
    eventLocation: string | null;
    setEventLocation: (eventLocation: string | null) => void;
}) {
    return (
        <EventDetailsForm
            onNext={onNext}
            eventName={eventName}
            setEventName={setEventName}
            eventDate={eventDate}
            setEventDate={setEventDate}
            eventLocation={eventLocation}
            setEventLocation={setEventLocation}
            showNextButton={true}
        />
    );
}
